import functions from '@/util/functions';
import { randomType2 } from './randomType2';
import { randomType3 } from './randomType3';
import { randomType4 } from './randomType4';
/**
 * 随机抽取试题
 * @param quesList 试题list
 * @param data 抽题条件
 * @return value
 */
export const randomSelection = (quesList, data) => {
    let obj = {}
    if (functions.isJSON(data)) {
        obj = JSON.parse(data)
    }
    if (obj.randomType == 2) {
        quesList = randomType2(quesList, obj.quesList)
    } else if (obj.randomType == 3){
        quesList = randomType3(quesList, obj.pageList)
    } else if (obj.randomType == 4){
        quesList = randomType4(quesList, obj.subsectionList)
    }
    return quesList
}